import React from "react";
import {BrowserRouter as Router, Route} from "react-router-dom";
import {
  ROUTING_APP_1,
  ROUTING_APP_2,
  ROUTING_LOGIN,
  ROUTING_TAB_1,
  ROUTING_TAB_2
} from './constants/routing'
import App1 from './components/App1'
import App2 from './components/App2'
import Home from './components/Home'
import LoginApp1 from './components/Login/LoginApp1'
import LoginApp2 from './components/Login/LoginApp2'
import Tab1 from './components/App1/Tab1'
import Tab2 from './components/App1/Tab2'
import Tab2App2 from './components/App2/Tab2'
import * as moment from 'moment';

export default class App extends React.Component {

  state = {
    inComingCallDuration: '',
    started: false
  };

  onStartCall = () => {
    let startTimestamp = moment().startOf("day");
    startTimestamp.add(1, 'second');
    if (!this.state.started) {
      this.setState({started: true, inComingCallDuration: startTimestamp.format('HH:mm:ss')});
      this.timer = setInterval(() => {
        startTimestamp.add(1, 'second');
        this.setState({inComingCallDuration: startTimestamp.format('HH:mm:ss')});
      }, 1000);
    } else {
      clearInterval(this.timer);
      this.setState({started: false, inComingCallDuration: ''});
    }

  };

  render() {
    return (
      <Router>
        <div>
          <Route path="/" exact component={Home}/>
          <Route path={"/" + ROUTING_APP_1} exact component={App1}/>
          <Route path={"/" + ROUTING_APP_1 + "/" + ROUTING_TAB_1}
                 component={() => <App1 onStartCall={this.onStartCall}
                                        inComingCallDuration={this.state.inComingCallDuration}/>}/>
          <Route path={"/" + ROUTING_APP_1 + "/" + ROUTING_TAB_2}
                 component={() => <App1 onStartCall={this.onStartCall}
                                        inComingCallDuration={this.state.inComingCallDuration}/>}/>
          <Route path={"/" + ROUTING_APP_1 + "/" + ROUTING_LOGIN} exact component={LoginApp1}/>
          <Route path={"/" + ROUTING_APP_1 + "/" + ROUTING_TAB_1} exact component={Tab1}/>
          <Route path={"/" + ROUTING_APP_1 + "/" + ROUTING_TAB_2} exact component={Tab2}/>
          <Route path={"/" + ROUTING_APP_2 + "/" + ROUTING_TAB_1} exact component={App2}/>
          <Route path={"/" + ROUTING_APP_2 + "/" + ROUTING_TAB_2} exact component={Tab2App2}/>
          <Route path={"/" + ROUTING_APP_2 + "/" + ROUTING_LOGIN} exact component={LoginApp2}/>
        </div>
      </Router>
    );
  }
}

